import { render, staticRenderFns } from "./SettingsWebhooksResponse.vue?vue&type=template&id=c5b05a90"
import script from "./SettingsWebhooksResponse.vue?vue&type=script&lang=js"
export * from "./SettingsWebhooksResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports